import View from "./View";
import {LOGO_TYPES, SERVICE_TYPES, groupArrayByNumber} from "../helpers";
import ScrollMagic from 'scrollmagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

class ServicesView extends View {
    _parentElement = document.querySelector('.main');

    addHandlerService(handler) {
        this._parentElement.classList.remove('main--transparent');
        this._parentElement.addEventListener('click', function (e) {
            const btn = e.target.closest('.btn-img--service');
            if (!btn) return;

            const serviceId = +btn.dataset.serviceId;
            handler(serviceId);
        });
    }

    _generateMarkup() {
        return `
            <section class="section-wrapper">
                ${this._generateMarkupSection(this._data.filter(service => service.type === SERVICE_TYPES.service))}
            </section>
            <section class="section-wrapper">
                ${this._generateMarkupSection(this._data.filter(service => service.type === SERVICE_TYPES.cloud))}
            </section>
            <section class="section-wrapper">
                ${this._generateMarkupSection(this._data.filter(service => service.type === SERVICE_TYPES.manual))}
            </section>
        `;
    }

    _generateMarkupSection(services) {
        const arrayOfArrayOfServices = groupArrayByNumber(services, 3);

        const markup = arrayOfArrayOfServices.map(arrayServices => {
            return `
            <div class="section animate-rash-section">
                ${arrayServices.map(service => this._generateMarkupService(service)).join('')}
            </div>
            `
        }).join('')

        console.log(markup);

        return markup;
        // return  arrayOfArrayOfServices.reduce((previousValue, accumulator) => {
        //     console.log(previousValue);
        //     return `
        //     <div class="animate-rash">
        //         ${previousValue}
        //     </div>
        //     `
        // }, '')
    }

    _generateMarkupService(service) {
        let imgClass = '';
        if (service.logoType === LOGO_TYPES.small) imgClass = 'btn-img__img--large';
        if (service.logoType === LOGO_TYPES.large) imgClass = 'btn-img__img--small';


        return `
            <a class="btn-img btn-img--service animate-rash" 
               data-service-id="${service.id}" 
               ${service.type !== SERVICE_TYPES.manual ? `href="/apliko/${service.id}" data-navigo` : `href="${service.pdf || service.urlWebsite}" target="_blank"`}>
                <img class="btn-img__img ${imgClass}" 
                     src="${service.logo}" 
                     alt="${service.name}Logo">
                <span class="btn-img__text">${service.name}</span>                  
            </a>
        `
    }

    addHandlerScrollAnimation() {

        const magicCont = new ScrollMagic.Controller();

        document.querySelectorAll('.animate-rash-section').forEach((domEl) => {
            const magicScene = new ScrollMagic.Scene({
                triggerElement: domEl,
                offset: 0,
                triggerHook: 0.9,
                reverse: false,
            });

            magicScene.on('start', function () {
                domEl.querySelectorAll('.animate-rash').forEach((innerDomEl, innerI) => {
                    setTimeout(function () {
                        innerDomEl.classList.add('animate__animated', 'animate__fadeIn');
                    }, innerI * 150);
                })
            })

            magicCont.addScene(magicScene);
        })

    }
}

export default new ServicesView();
